import React from 'react';
import * as svg from './SVGDefinitions';
import { useStyles } from './Icon.styles';
import { appPalette } from 'theme/App.palette';

const colors = appPalette.colors;

interface IIconDef {
  svg: JSX.Element;
  box: string;
}

export enum Icons {
  info = 'info',
  arrow = 'arrow',
  thinCaretRight = 'thinCaretRight',
  checkboxDefault = 'checkboxDefault',
  checkboxSelected = 'checkboxSelected',
  x = 'x',
  close = 'close',
  collapse = 'collapse',
  expand = 'expand',
  dot = 'dot',
  caretDown = 'caretDown',
  caretLeft = 'caretLeft',
  caretRight = 'caretRight',
  caretUP = 'caretUP',
  rotate360 = 'rotate360',
  rotate360NoText = 'rotate360NoText',
  edit = 'edit',
  FWD = 'FWD',
  SH_AWD = 'SH_AWD',
  link = 'link',
  arrowLeft = 'arrowLeft',
  arrowRight = 'arrowRight',
  circlePlus = 'circlePlus',
  circleMinus = 'circleMinus',
  check = 'check',
  plus2 = 'plus2',
  plus = 'plus',
  minus = 'minus',
  magGlass = 'magGlass',
  compass = 'compass',
  arrowStrong = 'arrowStrong',
  directions = 'directions',
  telephone = 'telephone',
  preferredDealerSelected = 'preferredDealerSelected',
  preferredDealer = 'preferredDealer',
  dealerPin = 'dealerPin',
  dealerPin2 = 'dealerPin2',
  redo = 'redo',
  ilxLogo = 'ilxLogo',
  integraLogo = 'integraLogo',
  tlxLogo = 'tlxLogo',
  rdxLogo = 'rdxLogo',
  mdxLogo = 'mdxLogo',
  location = 'location',
  infoI = 'infoI',
  clock = 'clock',
  blackRookLogo = 'blackRookLogo',
  circledCheck = 'circledCheck',
  longDealerPin = 'longDealerPin',
  filledTelephone = 'filledTelephone',
  filledDirections = 'filledDirections',
  pathPin = 'pathPin',
  chat = 'chat',
  email = 'email',
  phone = 'phone',
  checkMark = 'checkMark',
  enlarge = 'enlarge',
  roundedCaretLeft = 'roundedCaretLeft',
}

const icons: { [type in Icons]: IIconDef } = {
  [Icons.info]: {
    svg: svg.info,
    box: '0 0 24 24',
  },
  [Icons.arrow]: {
    svg: svg.arrow,
    box: '0 0 10 10',
  },
  [Icons.thinCaretRight]: {
    svg: svg.thinCaretRight,
    box: '0 0 88.7 200',
  },
  [Icons.checkboxDefault]: {
    svg: svg.checkboxDefault,
    box: '0 0 24 24',
  },
  [Icons.checkboxSelected]: {
    svg: svg.checkboxSelected,
    box: '0 0 24 24',
  },
  [Icons.x]: {
    svg: svg.x,
    box: '0 0 12 12',
  },
  [Icons.close]: {
    svg: svg.close,
    box: '0 0 32 32',
  },
  [Icons.circlePlus]: {
    svg: svg.circlePlus,
    box: '0 -2 210 210',
  },
  [Icons.circleMinus]: {
    svg: svg.circleMinus,
    box: '0 -2 210 210',
  },
  [Icons.collapse]: {
    svg: svg.collapse,
    box: '0 0 32 32',
  },
  [Icons.expand]: {
    svg: svg.expand,
    box: '0 0 32 32',
  },
  [Icons.dot]: {
    svg: svg.dot,
    box: '0 0 200 200',
  },
  [Icons.caretLeft]: {
    svg: svg.caretLeft,
    box: '0 0 13 20',
  },
  [Icons.caretRight]: {
    svg: svg.caretRight,
    box: '0 0 13 20',
  },
  [Icons.caretUP]: {
    svg: svg.caretUP,
    box: '0 0 20 13',
  },
  [Icons.caretDown]: {
    svg: svg.caretDown,
    box: '0 0 20 13',
  },
  [Icons.rotate360]: {
    svg: svg.rotate360,
    box: '0 0 136 60',
  },
  [Icons.rotate360NoText]: {
    svg: svg.rotate360NoText,
    box: '0 0 75 35.205',
  },
  [Icons.edit]: {
    svg: svg.edit,
    box: '0 0 17 17',
  },
  [Icons.FWD]: {
    svg: svg.FWD,
    box: '0 0 36 56',
  },
  [Icons.SH_AWD]: {
    svg: svg.SH_AWD,
    box: '0 0 36 56',
  },
  [Icons.link]: {
    svg: svg.link,
    box: '0 0 24 12',
  },
  [Icons.arrowLeft]: {
    svg: svg.arrowLeft,
    box: '0 0 20 42',
  },
  [Icons.arrowRight]: {
    svg: svg.arrowRight,
    box: '0 0 20 42',
  },
  [Icons.check]: {
    svg: svg.check,
    box: '0 0 16 12',
  },
  [Icons.plus2]: {
    svg: svg.plus2,
    box: '0 0 16 16',
  },
  [Icons.plus]: {
    svg: svg.plus,
    box: '0 0 16 16',
  },
  [Icons.minus]: {
    svg: svg.minus,
    box: '0 0 16 1.5',
  },
  [Icons.magGlass]: {
    svg: svg.magGlass,
    box: '0 0 200 200',
  },
  [Icons.compass]: {
    svg: svg.compass,
    box: '0 0 20 20',
  },
  [Icons.arrowStrong]: {
    svg: svg.arrowStrong,
    box: '-448.9 -0.5 1059.7 791.8',
  },
  [Icons.directions]: {
    svg: svg.directions,
    box: '0 0 34.93 34.93',
  },
  [Icons.telephone]: {
    svg: svg.telephone,
    box: '0 0 34.93 34.93',
  },
  [Icons.preferredDealerSelected]: {
    svg: svg.preferredDealerSelected,
    box: '0 0 38.024 43.573',
  },
  [Icons.preferredDealer]: {
    svg: svg.preferredDealer,
    box: '0 0 28 32',
  },
  [Icons.dealerPin]: {
    svg: svg.dealerPin,
    box: '0 0 30 36',
  },
  [Icons.dealerPin2]: {
    svg: svg.dealerPin2,
    box: '0 0 137.1 200',
  },
  [Icons.redo]: {
    svg: svg.redo,
    box: '0 0 16 13.333',
  },
  [Icons.ilxLogo]: {
    svg: svg.ilxLogo,
    box: '0 0 200 32',
  },
  [Icons.integraLogo]: {
    svg: svg.integraLogo,
    box: '0 0 476.8 34.2',
  },
  [Icons.tlxLogo]: {
    svg: svg.tlxLogo,
    box: '0 0 270 34.2',
  },
  [Icons.rdxLogo]: {
    svg: svg.rdxLogo,
    box: '0 0 280 34.2',
  },
  [Icons.mdxLogo]: {
    svg: svg.mdxLogo,
    box: '0 0 288.4 34.2',
  },
  [Icons.location]: {
    svg: svg.location,
    box: '0 0 137.1 200',
  },
  [Icons.infoI]: {
    svg: svg.infoI,
    box: '0 0 7 20',
  },
  [Icons.clock]: {
    svg: svg.clock,
    box: '0 0 22 22',
  },
  [Icons.blackRookLogo]: {
    svg: svg.blackRookLogo,
    box: '0 0 124 65',
  },
  [Icons.circledCheck]: {
    svg: svg.circledCheck,
    box: '0 0 200 200',
  },
  [Icons.longDealerPin]: {
    svg: svg.longDealerPin,
    box: '0 0 27 35',
  },
  [Icons.filledTelephone]: {
    svg: svg.filledTelephone,
    box: '0 0 29 29',
  },
  [Icons.filledDirections]: {
    svg: svg.filledDirections,
    box: '0 0 26 26',
  },
  [Icons.pathPin]: {
    svg: svg.pathPin,
    box: '0 0 27 35',
  },
  [Icons.chat]: {
    svg: svg.chat,
    box: '2.25 3.75 19.5 16.5',
  },
  [Icons.email]: {
    svg: svg.email,
    box: '5.25 0.79 17.5 19.25',
  },
  [Icons.phone]: {
    svg: svg.phone,
    box: '0 0 20 20',
  },
  [Icons.checkMark]: {
    svg: svg.checkMark,
    box: '0 0 24 24',
  },
  [Icons.enlarge]: {
    svg: svg.enlarge(),
    box: '0 0 28 29',
  },
  [Icons.roundedCaretLeft]: {
    svg: svg.roundedCaretLeft,
    box: '0 0 6 9',
  },
};

interface IIconProps {
  type?: Icons;
  className?: string;
  color?: string;
  svgProps?: any;
  isDecorative?: boolean;
}

export function Icon(props: IIconProps): JSX.Element {
  const { type, className, color, svgProps } = props;
  const classes = useStyles({ color: color || colors.black });
  const iconData: IIconDef | null = type ? icons[type] : null;
  const svgMod = type === Icons.enlarge ? svg.enlarge(color) : iconData?.svg;

  if (type && iconData) {
    return (
      <svg
        aria-hidden={props.isDecorative}
        xmlns="http://www.w3.org/2000/svg"
        className={`${classes.icon_container} ${className || ''}`}
        viewBox={iconData.box}
        {...svgProps}
      >
        {svgMod}
      </svg>
    );
  }

  return <></>;
}
